import { FC } from "react";

import { Button, Modal } from "antd";

import { IContractor } from "store/contractors/contractors.types";

interface IContractorsDeleteModalProps {
  deletingContractor: IContractor | null;
  onCancel: () => void;
  onConfirm: () => void;
}

const ContractorsDeleteModal: FC<IContractorsDeleteModalProps> = ({
  deletingContractor,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      className="user-accept-modal-wrapper"
      open={ !!deletingContractor }
      onCancel={ onCancel }
      footer={ null }
      width={ 500 }
    >
      <>
        <h4 className="modal-title">
          Are you sure you want to delete
          { " " }
          <span>{ deletingContractor?.name }</span>?
        </h4>

        <div>
          This action cannot be undone.
        </div>

        <div className="action-wrapper">
          <Button
            type="primary"
            danger
            onClick={ onConfirm }
          >
            Yes
          </Button>

          <Button onClick={ onCancel }>
            No
          </Button>
        </div>
      </>
    </Modal>
  );
};

export default ContractorsDeleteModal;
